export const IconStrokeColor = {
  Gray: '#9DA0A6',
  Red: '#91121C'
};
